import type { ReactNode } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { cn } from '@/lib/utils';
import { SETTINGS_SELECT_CONTENT_CLASS, SETTINGS_SELECT_ITEM_CLASS, SETTINGS_SELECT_TRIGGER_CLASS } from './settings-ui';

interface SettingsSelectProps {
	value: string;
	onValueChange: (value: string) => void;
	options: { value: string; label: ReactNode }[];
	placeholder?: string;
	disabled?: boolean;
	invalid?: boolean;
	id?: string;
	'aria-label'?: string;
	className?: string;
}

/** A settings dropdown: the input-style trigger with Figma's glass list. Option values must not be empty. */
export function SettingsSelect({ value, onValueChange, options, placeholder, disabled, invalid, id, className, ...rest }: SettingsSelectProps) {
	return (
		<Select value={value} onValueChange={onValueChange} disabled={disabled}>
			<SelectTrigger
				id={id}
				aria-label={rest['aria-label']}
				aria-invalid={invalid || undefined}
				className={cn(SETTINGS_SELECT_TRIGGER_CLASS, 'cursor-pointer', className)}
			>
				<SelectValue placeholder={placeholder} />
			</SelectTrigger>
			<SelectContent className={SETTINGS_SELECT_CONTENT_CLASS}>
				{options.map((option) => (
					<SelectItem key={option.value} value={option.value} className={SETTINGS_SELECT_ITEM_CLASS}>
						{option.label}
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	);
}
